import { Link } from "react-router-dom";

export default function SEOFooter() {
  return (
    <footer className="bg-card/50 border-t border-border/50 mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-black text-primary">67 CHAOS</h3>
            <p className="text-sm text-muted-foreground">
              The viral multiplayer party game based on the 67 meme. 
              Hit exactly 67 together with friends!
            </p>
            <p className="text-xs text-muted-foreground">
              Celebrating Dictionary.com's 2025 Word of the Year
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-bold text-foreground">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Play Now
              </Link>
              <Link to="/how-to-play" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                How to Play
              </Link>
              <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                About 67 CHAOS
              </Link>
            </nav>
          </div>

          {/* Game Features */}
          <div className="space-y-4">
            <h4 className="font-bold text-foreground">Features</h4>
            <ul className="text-sm text-muted-foreground space-y-2">
              <li>Free Online Multiplayer</li>
              <li>2-8 Players Per Room</li>
              <li>Mobile & Desktop</li>
              <li>No Download Required</li>
              <li>Practice Mode with AI</li>
            </ul>
          </div>

          {/* Social & SEO Keywords */}
          <div className="space-y-4">
            <h4 className="font-bold text-foreground">Keywords</h4>
            <div className="mt-4">
              <p className="text-xs text-muted-foreground">
                #67chaos #SixSeven #67meme #GenAlpha #PartyGame #BrowserGame #FreeGame
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border/30 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} KUL Games. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            67 CHAOS — The Viral Gen Alpha Party Game | Dictionary.com 2025 Word of the Year
          </p>
        </div>
      </div>
    </footer>
  );
}
